module.exports = __webpack_public_path__ + "img/page02.a0e37be7.png";